<template>
  <v-dialog v-model="modal" fullscreen persistent>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Associer une ou plusieurs instances</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text class="pt-0">
        <v-stepper v-model="step" vertical>
          <v-stepper-step step="1" :complete="step1Ok">
            Sélection d'instances
          </v-stepper-step>

          <v-stepper-content step="1">
            <dialogRechercheSimpleInstance
              ref="recherche"
              @input="ajouterInstance"
            />
            <p>
              Sélectionner une ou plusieurs instances dans lesquels rajouter le
              contact.
            </p>
            <v-data-table
              :headers="headersInstance"
              :items="selectedInstance"
              dense
            >
              <template #top>
                <v-btn @click="rechercheInstance">Ajouter</v-btn>
              </template>
              <template #item.action="{ item }">
                <template v-if="!!item.erreurs">
                  <v-icon color="error">mdi-alert-circle</v-icon>
                </template>
              </template>
            </v-data-table>

            <v-btn
              color="primary"
              :disabled="!selectedInstance.length"
              @click="poursuivreVersConfirmation"
            >
              Poursuivre
            </v-btn>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step2Ok">
            Confirmer les données
          </v-stepper-step>

          <v-stepper-content step="2">
            <p>
              Vous aller demander le rajout du contact à
              {{ selectedInstance.length }} instance(s).
            </p>

            <v-form ref="validation" class="mb-1">
              <v-textarea
                counter
                filled
                label="Commentaire"
                v-model="commentaire"
                :rules="[size255Rule()]"
                hide-details="auto"
              ></v-textarea>

              <v-select
                return-object
                dense
                filled
                :items="enums.typesParticipant"
                item-text="libelle"
                :label="$t('personnePhysique.detail.form.typeParticipant')"
                hide-details="auto"
                :rules="[obligatoireRule()]"
                v-model="typeParticipant"
              >
                <template #selection="{ item }">
                  {{ item.libelle }}
                </template>
              </v-select>
            </v-form>

            <p>Voulez vous continuer ?</p>
            <v-btn color="primary" @click="demarrerCreation">
              Poursuivre
            </v-btn>
            <v-btn text @click="annuler2"> Annuler </v-btn>
          </v-stepper-content>

          <v-stepper-step step="3">
            Création des demandes
          </v-stepper-step>

          <v-stepper-content step="3">
            <template v-if="working">
              <p>
                Création des demandes, veuillez patientier.
              </p>
            </template>
            <template v-else>
              <p>
                Le processus est terminé. {{ nombreCree }} demande(s) ont été
                créé(s).
              </p>
              <p>
                <v-btn @click="closeModal" primary>
                  Fermer
                </v-btn>
              </p>
            </template>
            <v-progress-circular
              :size="100"
              :width="15"
              :value="progressValue"
              color="primary"
            >
              {{ indexCreation }} / {{ selectedInstance.length }}
            </v-progress-circular>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogRechercheSimpleInstance from './DialogRechercheSimpleInstance';
import ValidationRules from '@/plugins/mixins/ValidationRules';
export default {
  components: {
    dialogRechercheSimpleInstance: DialogRechercheSimpleInstance,
  },
  mixins: [ValidationRules],
  props: {
    subtitle: {
      type: String,
    },
  },
  data() {
    return {
      contact: {},
      selectedInstance: [],
      headersInstance: [
        {
          value: 'nom',
          sortable: false,
          text: this.$t('recherche.rechercheSimple.instance.list.headers.nom'),
        },
        {
          value: 'referent',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.referent',
          ),
        },
        {
          value: 'nomsGestionnaires',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.personnePhysique',
          ),
        },
        {
          value: 'size',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.numberOfUser',
          ),
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          width: '30px',
        },
      ],
      enums: {
        typesParticipant: [],
      },
      typeParticipant: null,
      commentaire: '',
      step: 1,
      modal: false,
      working: false,
      done: false,
      nombreCree: 0,
      indexCreation: 0,
    };
  },
  methods: {
    show(contact) {
      this.$api('enums/instance')
        .get()
        .then(response => {
          const body = response.body;
          const enums = this.enums;
          enums.typesParticipant = body.typesParticipant;
          this.step = 1;
          this.contact = contact;
          this.selectedInstance = [];
          this.modal = true;
        });
    },
    ajouterInstance(instance) {
      this.selectedInstance.push(instance);
    },
    poursuivreVersConfirmation() {
      this.step = 2;
    },
    demarrerCreation() {
      if (!this.$refs.validation.validate()) {
        return;
      }

      this.nombreCree = 0;
      this.indexCreation = 0;
      this.working = false;
      this.step = 3;
      this.processNextCreation();
    },
    processNextCreation() {
      if (this.indexCreation >= this.selectedInstance.length) {
        this.working = false;
        this.done = false;
        return;
      }

      const instance = this.selectedInstance[this.indexCreation];
      const rajout = {
        typeParticipant: this.typeParticipant,
        commentaire: this.commentaire,
        contact: { id: this.contact.id },
      };
      this.$api(`workflow/instance/${instance.id}/ajout`)
        .post(rajout)
        .then(() => {
          this.nombreCree++;
        })
        .catch(() => {
          //TODO
        })
        .finally(() => {
          this.indexCreation++;
          this.processNextCreation();
        });
    },
    annuler2() {
      this.step = 1;
    },
    rechercheInstance() {
      const ids = this.contact.instances.map(i => i.idInstance);
      this.$refs.recherche.show(ids);
    },
    closeModal() {
      this.modal = false;
    },
  },
  computed: {
    step1Ok() {
      return this.step > 1;
    },
    step2Ok() {
      return this.step > 2;
    },
    step3Ok() {
      return this.done;
    },
    progressValue() {
      const l = this.selectedInstance.length;
      if (!l) return 0;
      return parseInt((parseFloat(this.indexCreation) / parseFloat(l)) * 100.0);
    },
  },
};
</script>
